import { useState } from "react";
import UserMenu from "./UserMenu";
import UserPreferencesModal from "./UserPreferencesModal";
import alffyLogo from "../assets/alffy-logo.png";
import MarketMarquee from "./MarketMarquee";

/**
 * TopBar
 *
 * A permanent, fixed-height navigation bar that appears at the top of every page.
 * Contains:
 *  - App branding (left)
 *  - Ticker marquee area (center)
 *  - Notifications bell + User avatar menu (right)
 */
export default function TopBar() {
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);
  const isGuest = localStorage.getItem("isGuest") === "true";

  return (
    <>
      <header className="topbar">
        {/* Left: App Branding */}
        <div className="topbar-left">
          <img src={alffyLogo} alt="alffy logo" className="topbar-logo-img" />
          <span className="topbar-brand">alffy</span>
        </div>

        {/* Center: Market Marquee (Global Indices & Commodities/FX) */}
        <div className="topbar-center">
          {!isGuest && (
            <>
              <MarketMarquee group="index" pixelsPerSecond={50} />
              <MarketMarquee group="commodity_fx" pixelsPerSecond={50} />
            </>
          )}
        </div>

        {/* Right: User Menu (notifications + avatar + dropdown) */}
        <div className="topbar-right">
          <UserMenu onPreferencesClick={() => setIsPreferencesOpen(true)} />
        </div>
      </header>

      {/* Preferences Modal (rendered at top level so it overlays everything) */}
      <UserPreferencesModal
        isOpen={isPreferencesOpen}
        onClose={() => setIsPreferencesOpen(false)}
      />
    </>
  );
}
